import { useContext } from "react";
import { PendingDealersActionContext } from "./PendingDealersActionContext";
import useGetPendingDealers from "./useGetPendingDealers";
import { Badge } from "react-bootstrap";

function usePendingDealersAction(): any {
  const get = useGetPendingDealers();
  const getFunction = () => get();

  const { count } = useContext(PendingDealersActionContext);

  const actionTemplate = (
    <>{count ? <Badge bg="warning">+{count}</Badge> : ""}</>
  );

  return { getFunction, actionTemplate };
}

export default usePendingDealersAction;
